import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GroupedButtonComponent } from './grouped-button.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ButtonModule } from 'primeng/button';


@NgModule({
  declarations: [GroupedButtonComponent],
  imports: [
    CommonModule,
    OverlayPanelModule,
    ButtonModule
  ],
  exports: [GroupedButtonComponent]
})
export class GroupedButtonModule { }
